/**
 * @module cercaliagl/BaseObject
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import EventEmitter from 'eventemitter3';
/**
 * @classdesc
 * Abstract class for internal purposes. It can be extended to have `get()` and `set()` methods for objects for its subclasses
 */
var BaseObject = /** @class */ (function (_super) {
    __extends(BaseObject, _super);
    /**
     * @constructor
     */
    function BaseObject() {
        var _this = _super.call(this) || this;
        /**
         * @private
         * @type {!Object<string, *>}
         */
        _this.values_ = {};
        return _this;
    }
    /**
     * Gets a value.
     * @param {string} key Key name.
     * @return {*} Value.
     * @api
     */
    BaseObject.prototype.get = function (key) {
        var value;
        if (Object.prototype.hasOwnProperty.call(this.values_, key)) {
            value = this.values_[key];
        }
        return value;
    };
    /**
     * Sets a value.
     * @param {string} key Key name.
     * @param {*} value Value.
     * @param {boolean} [silent] Update without triggering an event.
     * @api
     */
    BaseObject.prototype.set = function (key, value) {
        this.values_[key] = value;
    };
    return BaseObject;
}(EventEmitter));
export default BaseObject;
//# sourceMappingURL=BaseObject.js.map